import { Dialog as DialogPrimitive } from "radix-ui";

const DialogPrimitiveRoot = DialogPrimitive.Root;
const DialogPrimitiveTrigger = DialogPrimitive.Trigger;
const DialogPrimitivePortal = DialogPrimitive.Portal;
const DialogPrimitiveOverlay = DialogPrimitive.Overlay;
const DialogPrimitiveContent = DialogPrimitive.Content;
const DialogPrimitiveTitle = DialogPrimitive.Title;
const DialogPrimitiveDescription = DialogPrimitive.Description;
const DialogPrimitiveClose = DialogPrimitive.Close;

DialogPrimitiveRoot.displayName = DialogPrimitive.Root.displayName;
DialogPrimitiveTrigger.displayName = DialogPrimitive.Trigger.displayName;
DialogPrimitivePortal.displayName = DialogPrimitive.Portal.displayName;
DialogPrimitiveOverlay.displayName = DialogPrimitive.Overlay.displayName;
DialogPrimitiveContent.displayName = DialogPrimitive.Content.displayName;
DialogPrimitiveTitle.displayName = DialogPrimitive.Title.displayName;
DialogPrimitiveDescription.displayName = DialogPrimitive.Description.displayName;
DialogPrimitiveClose.displayName = DialogPrimitive.Close.displayName;

export {
  DialogPrimitiveClose,
  DialogPrimitiveContent,
  DialogPrimitiveDescription,
  DialogPrimitiveOverlay,
  DialogPrimitivePortal,
  DialogPrimitiveRoot,
  DialogPrimitiveTitle,
  DialogPrimitiveTrigger,
};
